// Único link de pago activo en la página.
// El plan "completo" ($29.900) quedó DESCONECTADO a pedido:
// apunta al mismo checkout que el plan activo para no dejar botones rotos.
const ACTIVE_CHECKOUT =
  'https://www.stockdigital.shop/checkouts/cn/hWNCLiCapo1uG5J1iGZMkjeE/es-ar?_r=AQABB-Z441w_eFWqCMBLvmt2gLjcAH0e2horzkxjyJkZvfU&cart_link_id=RoKDeRBE&preview_theme_id=140123340859'

export const CHECKOUT_LINKS = {
  esencial: ACTIVE_CHECKOUT,
  completo: ACTIVE_CHECKOUT,
} as const
